export default __webpack_public_path__ + "static/media/486.8aeec8c4.png";